export enum LoanFeeType {
  COMMITMENT_FEE = 'Commitment',
  UTILIZATION_FEE = 'Utilization',
  EXTENSION_FEE = 'Extension',
  EXIT_FEE = 'Exit',
}

export interface LoanFee {
  id: string
  name: string
}

export type LoanFeeTypeKey = keyof typeof LoanFeeType

export const loanFeeTypes: LoanFee[] = Object.entries(LoanFeeType).map(
  ([propertyKey]) => ({ id: propertyKey, name: propertyKey }),
)

export const loanFeeTypeKeys = Object.keys(LoanFeeType) as LoanFeeTypeKey[]
